import { useEffect } from "react";
import { useLang, pathFor, SITE_URL } from "@/i18n/LangContext";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

const setLink = (rel, href, hreflang) => {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.head.querySelector(sel);
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); if (hreflang) el.setAttribute("hreflang", hreflang); document.head.appendChild(el); }
  el.setAttribute("href", href);
};

export function Seo() {
  const { lang, t, pageKey } = useLang();
  const key = pageKey || "notFound";
  const meta = t.seo[key];

  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = meta.title;
    setMeta("name", "description", meta.description);
    setMeta("property", "og:title", meta.title);
    setMeta("property", "og:description", meta.description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "SIDLY");
    setMeta("property", "og:locale", lang === "fr" ? "fr_FR" : "en_GB");
    setMeta("name", "robots", pageKey ? "index,follow" : "noindex");
    if (pageKey) {
      const frUrl = SITE_URL + pathFor(pageKey, "fr");
      const enUrl = SITE_URL + pathFor(pageKey, "en");
      setLink("canonical", lang === "fr" ? frUrl : enUrl);
      setLink("alternate", frUrl, "fr");
      setLink("alternate", enUrl, "en");
      setLink("alternate", frUrl, "x-default");
      setMeta("property", "og:url", lang === "fr" ? frUrl : enUrl);
    }
  }, [lang, meta, pageKey]);

  return null;
}
